import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const account_id = Number(process.env.REACT_APP_ACCOUNT_ID);
const base_application_url = process.env.REACT_APP_APPLICATION;

const LOCAL_STORAGE = process.env.REACT_APP_LOCAL_STORAGE;
const LOCAL_TOKEN = process.env.REACT_APP_LOCAL_TOKEN;
const LOCAL_TOKEN_HOROSCOPE = process.env.REACT_APP_LOCAL_TOKEN_HOROSCOPE;
const REFRESH_TOKEN = process.env.REACT_APP_REFRESH_TOKEN;

let tokenPromise = null;
let userTokenPromise = null;

/*GLOBAL TOKEN*/

export async function getToken() {
  if (tokenPromise) return tokenPromise;

  tokenPromise = (async () => {
    const res = await axios.get(`${BASE_URL}/init/generate`, {
      params: {
        account_id,
        application: base_application_url,
      },
      headers: {
        "X-source-application": base_application_url,
      },
    });

    const token = res.data.data.token;

    localStorage.setItem(
      LOCAL_STORAGE,
      JSON.stringify({
        token,
        expiresAt: Date.now() + 10 * 60 * 1000,
      })
    );

    return token;
  })();

  try {
    return await tokenPromise;
  } finally {
    tokenPromise = null;
  }
}

export function getStoredToken() {
  const data = JSON.parse(localStorage.getItem(LOCAL_STORAGE));

  if (!data) return null;

  if (Date.now() > data.expiresAt) {
    localStorage.removeItem(LOCAL_STORAGE);
    return null;
  }

  return data.token;
}

/*USER TOKEN*/

export function getStoredUserToken() {
  let data = JSON.parse(localStorage.getItem(LOCAL_TOKEN));

  if (!data) {
    data = JSON.parse(localStorage.getItem(LOCAL_TOKEN_HOROSCOPE));
  }

  if (!data) return null;

  if (Date.now() > data.expiresAt) {
    return null;
  }

  return data;
}

export function hasLoggedUser() {
  return Boolean(
    localStorage.getItem(LOCAL_TOKEN) ||
      localStorage.getItem(LOCAL_TOKEN_HOROSCOPE) ||
      localStorage.getItem(REFRESH_TOKEN)
  );
}

/*REFRESH USER TOKEN*/

export async function refreshUserToken() {
  if (userTokenPromise) {
    return userTokenPromise;
  }

  userTokenPromise = (async () => {
    let token = getStoredToken();

    if (!token) {
      token = await getToken();
    }

    const storedUser =
      JSON.parse(localStorage.getItem(LOCAL_TOKEN)) ||
      JSON.parse(localStorage.getItem(LOCAL_TOKEN_HOROSCOPE));

    const refresh_token =
      storedUser?.refresh_token ||
      localStorage.getItem(REFRESH_TOKEN);

    if (!refresh_token) {
      localStorage.removeItem(LOCAL_TOKEN);
      localStorage.removeItem(LOCAL_TOKEN_HOROSCOPE);
      localStorage.removeItem(REFRESH_TOKEN);
      return null;
    }

    try {
      const res = await axios.post(
        `${BASE_URL}/accounts/token/refresh`,
        {
          refresh_token,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "X-source-application": base_application_url,
          },
        }
      );

      const newData = {
        token: res.data.data.token,
        refresh_token: res.data.data.refresh_token,
        expiresAt: Date.now() + 60 * 60 * 1000,
      };

      if (localStorage.getItem(LOCAL_TOKEN)) {
        localStorage.setItem(
          LOCAL_TOKEN,
          JSON.stringify(newData)
        );
      } else {
        localStorage.setItem(
          LOCAL_TOKEN_HOROSCOPE,
          JSON.stringify(newData)
        );
      }

      localStorage.setItem(
        REFRESH_TOKEN,
        newData.refresh_token
      );

      return newData.token;
    } catch (error) {
      localStorage.removeItem(LOCAL_TOKEN);
      localStorage.removeItem(LOCAL_TOKEN_HOROSCOPE);
      localStorage.removeItem(REFRESH_TOKEN);

      return null;
    }
  })();

  try {
    return await userTokenPromise;
  } finally {
    userTokenPromise = null;
  }
}
/* export async function refreshUserToken() {
  let token = getStoredToken();
  const refresh_token = localStorage.getItem(REFRESH_TOKEN);
  if (!refresh_token) {
    localStorage.removeItem(LOCAL_TOKEN);
    return null;
  }
  if (!token) {
    token = await getToken();
  }

  try {
    const res = await axios.post(
      `${BASE_URL}/accounts/token/refresh`,
      { refresh_token },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "X-source-application": `${base_application_url}`
        },
      },
    );

    const newData = {
      token: res.data.data.token,
      refresh_token: res.data.data.refresh_token,
      expiresAt: Date.now() + 60 * 60 * 1000,
    };

    localStorage.setItem(LOCAL_TOKEN, JSON.stringify(newData));
    localStorage.setItem(REFRESH_TOKEN, newData.refresh_token);

    return newData.token;
  } catch (error) {
   // localStorage.removeItem(LOCAL_TOKEN);
    //localStorage.removeItem(REFRESH_TOKEN);

    //window.location.href = "/signin";

    return null;
  }
} 




/* import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const account_id = Number(process.env.REACT_APP_ACCOUNT_ID);
const base_application_url = process.env.REACT_APP_APPLICATION;

let tokenPromise = null;
let userTokenPromise = null;

export async function getToken() {
  if (tokenPromise) return tokenPromise;

  tokenPromise = (async () => {
  try {
    const res = await axios.get(`${BASE_URL}/init/generate`, {
      params: {
        account_id,
        application: base_application_url,
      },
      headers: {
        "X-source-application": base_application_url,
      },
    });

    const token = res.data.data.token;

    localStorage.setItem(
      process.env.REACT_APP_LOCAL_STORAGE,
      JSON.stringify({
        token,
        expiresAt: Date.now() + 10 * 60 * 1000,
      })
    );

    return token;
  } finally {
    tokenPromise = null;
  }
})();

  return tokenPromise;
}

export function getStoredToken() {
  const data = JSON.parse(
    localStorage.getItem(`${process.env.REACT_APP_LOCAL_STORAGE}`),
  );
  if (!data) return null;

  if (Date.now() > data.expiresAt) {
    localStorage.removeItem(`${process.env.REACT_APP_LOCAL_STORAGE}`);
    return null;
  }

  return data.token;
}

export function getStoredUserToken() {
  let data = JSON.parse(
    localStorage.getItem(`${process.env.REACT_APP_LOCAL_TOKEN}`),
  );
  if (!data) {
    data = JSON.parse(
      localStorage.getItem(`${process.env.REACT_APP_LOCAL_TOKEN_HOROSCOPE}`),
    );
  }
  if (!data) return null;
  if (Date.now() > data.expiresAt) {
    localStorage.removeItem(`${process.env.REACT_APP_LOCAL_TOKEN}`);
    localStorage.removeItem(`${process.env.REACT_APP_LOCAL_TOKEN_HOROSCOPE}`);
    return null;
  }
  return data;
}

export async function refreshUserToken() {
  let token = getStoredToken();

  const storedUser =
    JSON.parse(localStorage.getItem(`${process.env.REACT_APP_LOCAL_TOKEN}`)) ||
    JSON.parse(
      localStorage.getItem(`${process.env.REACT_APP_LOCAL_TOKEN_HOROSCOPE}`),
    );

  const refresh_token =
    localStorage.getItem(`${process.env.REACT_APP_REFRESH_TOKEN}`);

  if (!refresh_token) {
    localStorage.removeItem(`${process.env.REACT_APP_LOCAL_TOKEN}`);
    localStorage.removeItem(`${process.env.REACT_APP_LOCAL_TOKEN_HOROSCOPE}`);
     localStorage.removeItem(process.env.REACT_APP_REFRESH_TOKEN);
    return null;
  }

  if (!token) {
    token = await getToken();
  }

  try {
    const res = await axios.post(
      `${BASE_URL}/accounts/token/refresh`,
      { refresh_token },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "X-source-application": `${base_application_url}`,
        },
      },
    );

    const newData = {
      token: res.data.data.token,
      refresh_token: res.data.data.refresh_token,
      expiresAt: Date.now() + 60 * 60 * 1000,
    };
    if (localStorage.getItem(`${process.env.REACT_APP_LOCAL_TOKEN}`)) {
      localStorage.setItem(
        `${process.env.REACT_APP_LOCAL_TOKEN}`,
        JSON.stringify(newData),
      );
    } else {
      localStorage.setItem(
        `${process.env.REACT_APP_LOCAL_TOKEN_HOROSCOPE}`,
        JSON.stringify(newData),
      );
    }

    localStorage.setItem(
      `${process.env.REACT_APP_REFRESH_TOKEN}`,
      newData.refresh_token,
    );

    return newData.token;
  } catch (error) {
    localStorage.removeItem(`${process.env.REACT_APP_LOCAL_TOKEN}`);
    localStorage.removeItem(`${process.env.REACT_APP_LOCAL_TOKEN_HOROSCOPE}`);
    localStorage.removeItem(`${process.env.REACT_APP_REFRESH_TOKEN}`);

    return null;
  }
}

export function clearExpiredTokens() {
  const keys = [
    process.env.REACT_APP_LOCAL_TOKEN,
    process.env.REACT_APP_LOCAL_TOKEN_HOROSCOPE,
  ];

  keys.forEach((key) => {
    const data = JSON.parse(localStorage.getItem(key));

    if (!data) return;

    if (Date.now() > data.expiresAt) {
      localStorage.removeItem(key);
    }
  });

  const hasUserToken =
    localStorage.getItem(
      process.env.REACT_APP_LOCAL_TOKEN
    ) ||
    localStorage.getItem(
      process.env.REACT_APP_LOCAL_TOKEN_HOROSCOPE
    );

  if (!hasUserToken) {
    localStorage.removeItem(
      process.env.REACT_APP_REFRESH_TOKEN
    );
  }
} */